import React, { Component } from 'react'
import { Typography } from '@mui/material'
import Box from "@mui/material/Box";
import wyzrTheme from '../../styles/customTheme';
export default class NoData extends Component {
    render() {
        return (
            <Box className="noDataContainer">
                <Typography variant="body1" fontWeight={700} color={wyzrTheme.palette.grey[500]}>
                    {this.props.text}
                </Typography>
            </Box>
        )
    }
}
